import "cruzo/ui-components/vars.css";
import "cruzo/ui-components/spinner.css";
import "./css/app.css";
import { Template, componentsRegistryService, RouteUrlBucket, routerService } from "cruzo";
import "./components/site-root.component";
import { SiteRootComponent } from "./components/site-root.component";

const routes = new RouteUrlBucket({
  home: {
    url: "/:section",
    componentSelectorUnbox: () => SiteRootComponent.selector,
    routeSelectorUnbox: () => ".router",
  },
});

routerService.setHashMode(true)

Template.setAppVariables({});
componentsRegistryService.initApp();
routerService.update()
